var map = {
	"./detox-title.svg": 1234,
	"./gachi-title.svg": 2230,
	"./gorgeous-title.svg": 2578,
	"./hero-title.svg": 1490,
	"./illustration-title.svg": 7635,
	"./search-title.svg": 1566,
	"./style-link-title.svg": 4448,
	"./type1-title.svg": 9426,
	"./type2-title.svg": 7224,
	"./type3-title.svg": 4189,
	"./type4-title.svg": 356,
	"./which-title.svg": 3367,
	"./yuru-title.svg": 2213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8317;